module.exports = "/_next/static/media/5206598a9379d590363326a1b851ec38.svg";